import React, { useEffect } from 'react';
import styled from '@emotion/styled';
import { Main } from '../../ui';
import { Accordions } from './components/Accordions';
import { Buttons } from './components/Buttons';
import { Divider } from './components/Divider';
import { FlexBoxes } from './components/FlexBoxes';
import { GridItems } from './components/GridItems';
import { Icons } from './components/Icons';
import { Selects } from './components/Selects';
import { Typography } from './components/Typography';
import { Images } from './components/Images';
import { Cards } from './components/Cards';
import { QuickLinks } from './components/QuickLinks';
import { Highlights } from './components/Highlights';
import { CallToActions } from './components/CallToActions';
import { ContactItems } from './components/ContactItems';
import { Alerts } from './components/Alerts';
import { AlertBanners } from './components/AlertBanners';
import { AutoSuggest } from './components/AutoSuggest';
import { AutoSuggestForm } from './components/AutoSuggestForm';
import { ErrorBoundaries } from './components/ErrorBoundaries';
import { Footers } from './components/Footers';
import { Search } from './components/Search';
import { Form } from './components/Form';
import { DatePickers } from './components/DatePickers';
import { Dialogs } from './components/Dialogs';
import { Chips } from './components/Chips';
import { Surfaces } from './components/Surfaces';
import { PageLoader } from './components/PageLoading';
import { useNavigate } from '../shared/router/useNavigate';
import ContentWrap from '../../ui/components/Layout/ContentWrap';

const StyleguideMain = styled(Main)`
	margin: 80px 0;

	@media (max-width: 1280px) {
		margin: 20px 0;
	}
`;

export const Styleguide = () => {
	const navigate = useNavigate();

	useEffect(() => {
		if (!process.env.NEXT_PUBLIC_SHOW_DEV_PAGE) {
			navigate('/');
		}
	}, [navigate]);

	if (!process.env.NEXT_PUBLIC_SHOW_DEV_PAGE) {
		return null;
	}
	return (
		<>
			<AlertBanners />

			<StyleguideMain>
				<ContentWrap>
					<Typography />

					<Divider />

					<Images />

					<Divider />

					<Icons />

					<Divider />

					<Buttons />

					<Divider />

					<Chips />

					<Divider />

					<CallToActions />

					<Divider />

					<FlexBoxes />

					<Divider />

					<GridItems />

					<Divider />

					<Accordions />

					<Divider />

					<Dialogs />

					<Divider />

					<Form />

					<Divider />

					<DatePickers />

					<Divider />

					<Selects />

					<Divider />

					<Search />

					<Divider />

					<AutoSuggest />

					<Divider />

					<AutoSuggestForm />

					<Divider />

					<Surfaces />

					<Divider />

					<Cards />

					<Divider />

					<Highlights />

					<Divider />

					<QuickLinks />

					<Divider />

					<ContactItems />

					<Divider />

					<Alerts />

					<Divider />

					<PageLoader />

					<Divider />
				</ContentWrap>
			</StyleguideMain>

			<ErrorBoundaries />

			<Footers />
		</>
	);
};
